import axios from 'axios';

export function getCookie(name) {
    const prefix = `${encodeURIComponent(name)}=`;
    const cookie = document.cookie.split('; ').find(item => item.startsWith(prefix));
    return cookie ? decodeURIComponent(cookie.slice(prefix.length)) : null;
}

export function clearLocalAuthState() {
    localStorage.removeItem('is_logged_in');
    localStorage.removeItem('token');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('user_name');
    localStorage.removeItem('email');
    localStorage.removeItem('role');
}

// Create an axios instance
const instance = axios.create({
    baseURL: `${process.env.VUE_APP_HOST_BECKEND}:${process.env.VUE_APP_PORT_BECKEND}/api/v1`,
    withCredentials: true

  });
  
// Add a request interceptor
instance.interceptors.request.use((config) => {
    const method = (config.method || 'get').toLowerCase();
    if (['post', 'put', 'patch', 'delete'].includes(method)) {
        const csrfToken = getCookie('csrf_token');
        if (csrfToken) {
            config.headers['X-CSRF-Token'] = csrfToken;
        }
    }
    return config;
}, (error) => {
    return Promise.reject(error);
});

// Add a response interceptor
instance.interceptors.response.use((response) => {
    
    if (response.status >= 200 && response.status < 300) {
   
        return response;
    } else {
        return Promise.reject(new Error(`Response returned with status code ${response.status}`));
    }
}, (error) => {
    const {status} = error.response || {};
    if (status === 401) {
        clearLocalAuthState();
        if (window.location.pathname !== '/login') {
            window.location.href = '/login';
        }
    }
    return Promise.reject(error);
});

export default instance;
